<template>
  <div class="message-wrapper center">
    <template v-if="errorLines.length > 0">
      <p v-for="(line, i) in errorLines" :key="i" class="text-message error-text">{{ line }}</p>
    </template>
    <template v-else>
      <p class="text-message">{{ $t('please_scan_barcode_line1') }}</p>
      <p class="text-message">{{ $t('please_scan_barcode_line2') }}</p>
    </template>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import { Prop } from 'vue-property-decorator'

@Options({
  name: 'ScannerMessageOverlay',
})
export default class ScannerMessageOverlay extends Vue {
  @Prop({ type: Array, default: () => [] }) errorLines!: string[]
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/mixins.scss';

.message-wrapper {
  color: $pure-white;
  position: absolute;
  text-align: center;
  padding: 0 2rem;
  width: 100%;
  box-sizing: border-box;
  font-size: 50px;

  &.center {
    top: 40%;
  }
}

.text-message {
  font-size: 40px !important;
  font-weight: bold;
}

.error-text {
  color: red !important;
}
</style>
